import { HelpCircle } from "lucide-react";
import FeatureFlags from "../../common/feature-flagging/FeatureFlags";
import { NavigationLinkProps } from "../../providers/Router";
import { FEATURE_PAYSLIPS } from "../../utils/UserAccessControlUtils";
import { HELP_CENTER_URL } from "./constants";

const HelpCenterRouter: NavigationLinkProps[] = [
  {
    id: "25c3c1d7-abdd-48af-863f-935c61c30025",
    title: "Help Center",
    description: "",
    path: HELP_CENTER_URL,
    auth: true,
    sidebar: false,
    secondarySidebar: true,
    icon: HelpCircle,
    isExternal: true,
    requiredFeature: FEATURE_PAYSLIPS,
    requiredPermissions: ["ANY"],
    requiredFeatureFlag: FeatureFlags.HELP_CENTER,
    isFeatureFlagged: true,
  },
];

export default HelpCenterRouter;
